import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { useIsMobile } from '../../hooks/useIsMobile'
import DynamicLink from '../atoms/DynamicLink'
import MinusIcon from '../icons/MinusIcon'
import PlusIcon from '../icons/PlusIcon'

const FooterUberUns = ({ heading, body }) => {
  const isMobile = useIsMobile()
  const [isUberUnsOpen, setUberUnsOpen] = useState(false)

  return (
    <>
      <div className="hidden mb-3 md:flex">
        <DynamicLink
          link={heading}
          className="underline text-[15px] font-bold leading-normal transition-colors hover:text-red-as"
        />
      </div>
      <div className="overflow-hidden border-b md:border-0 border-gray-4">
        <button
          type="button"
          className="text-[15px] font-bold md:hidden py-4 flex items-center justify-between w-full"
          onClick={() => setUberUnsOpen(!isUberUnsOpen)}
        >
          <span>{heading.text}</span>
          {isUberUnsOpen ? <MinusIcon /> : <PlusIcon />}
        </button>
        <motion.div
          animate={{ height: isUberUnsOpen || !isMobile ? 'auto' : 0 }}
          transition={{ type: 'ease' }}
        >
          <div
            className="pb-4 pl-2 lg:pb-0 md:pl-0 lg:mb-16 u-p-small link-wrapper"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </motion.div>
      </div>
    </>
  )
}

export default FooterUberUns
